import { Controller } from "@hotwired/stimulus"

// Drag a .pem/.crt file onto the certificate field (or paste it). Shows a "Drop here" overlay while a
// file is dragged over the field; the textarea stays the source of truth.
export default class extends Controller {
  static targets = ["field", "overlay"]

  dragover(event) {
    if (!event.dataTransfer.types.includes("Files")) return
    event.preventDefault()
    this.overlayTarget.classList.remove("hidden")
  }

  dragleave(event) {
    if (event.relatedTarget && this.element.contains(event.relatedTarget)) return
    this.overlayTarget.classList.add("hidden")
  }

  drop(event) {
    if (!event.dataTransfer.types.includes("Files")) return
    event.preventDefault()
    this.overlayTarget.classList.add("hidden")
    this.loadFile(event.dataTransfer.files[0])
  }

  loadFile(file) {
    if (!file) return
    const reader = new FileReader()
    reader.onload = () => { this.fieldTarget.value = reader.result.trim() }
    reader.readAsText(file)
  }
}
